 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ACOVER from '@/components/1-cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDAD1 from '@/components/Backed/ad1'
 import LOVE_1 from '@/components/love_1'
 import ATITLE_PAGE from '@/components/2-title_page'
 import ATOC from '@/components/3-TOC'
 import V11COVER from '@/components/v1/1-cover'
 import V12TITLE_PAGE from '@/components/v1/2-title_page'
 import V13DEDICATION from '@/components/v1/3-dedication'
 import V14TOC from '@/components/v1/4-TOC'
 import V15START from '@/components/v1/5-start'
 import V16CHAP2 from '@/components/v1/6-chap2'
 import V17CHAP3 from '@/components/v1/7-chap3'
 import V18CHAP4 from '@/components/v1/8-chap4'
 import V19CHAP5 from '@/components/v1/9-chap5'
 import V110CHAP6 from '@/components/v1/10-chap6'
 import V111CHAP7 from '@/components/v1/11-chap7'
 import V112CHAP8 from '@/components/v1/12-chap8'
 import V113CHAP9 from '@/components/v1/13-chap9'
 import V114CHAP10 from '@/components/v1/14-chap10'
 import V115CHAP11 from '@/components/v1/15-chap11'
 import V116CHAP12 from '@/components/v1/16-chap12'
 import V117CHAP13 from '@/components/v1/17-chap13'
 import V118CHAP14 from '@/components/v1/18-chap14'
 import V119CHAP15 from '@/components/v1/19-chap15'
 import V120CHAP16 from '@/components/v1/20-chap16'
 import V121CHAP17 from '@/components/v1/21-chap17'
 import V122CHAP18 from '@/components/v1/22-chap18'
 import V123CHAP19 from '@/components/v1/23-chap19'
 import V124CHAP20 from '@/components/v1/24-chap20'
 import V125CHAP21 from '@/components/v1/25-chap21'
 import V126CHAP22 from '@/components/v1/26-chap22'
 import V127CHAP23 from '@/components/v1/27-chap23'
 import V128CHAP24 from '@/components/v1/28-chap24'
 import V129CHAP25 from '@/components/v1/29-chap25'
 import V130PART from '@/components/v1/30-part'
 import V21COVER from '@/components/v2/1-cover'
 import V22TITLE_PAGE from '@/components/v2/2-title_page'
 import V23DEDICATION from '@/components/v2/3-dedication'
 import V24TOC from '@/components/v2/4-TOC'
 import V25START from '@/components/v2/5-start'
 import V26CHAP2 from '@/components/v2/6-chap2'
 import V27CHAP3 from '@/components/v2/7-chap3'
 import V28CHAP4 from '@/components/v2/8-chap4'
 import V29CHAP5 from '@/components/v2/9-chap5'
 import V210CHAP6 from '@/components/v2/10-chap6'
 import V211CHAP7 from '@/components/v2/11-chap7'
 import V212CHAP8 from '@/components/v2/12-chap8'
 import V213CHAP9 from '@/components/v2/13-chap9'
 import V214CHAP10 from '@/components/v2/14-chap10'
 import V215CHAP11 from '@/components/v2/15-chap11'
 import V216CHAP12 from '@/components/v2/16-chap12'
 import V217CHAP13 from '@/components/v2/17-chap13'
 import V218CHAP14 from '@/components/v2/18-chap14'
 import V219CHAP15 from '@/components/v2/19-chap15'
 import V220CHAP16 from '@/components/v2/20-chap16'
 import V221CHAP17 from '@/components/v2/21-chap17'
 import V222CHAP18 from '@/components/v2/22-chap18'
 import V223CHAP19 from '@/components/v2/23-chap19'
 import V224CHAP20 from '@/components/v2/24-chap20'
 import V225CHAP21 from '@/components/v2/25-chap21'
 import V226CHAP22 from '@/components/v2/26-chap22'
 import V227CHAP23 from '@/components/v2/27-chap23'
 import V228CHAP24 from '@/components/v2/28-chap24'
 import V229CHAP25 from '@/components/v2/29-chap25'
 import V230CHAP26 from '@/components/v2/30-chap26'
 import V231CHAP27 from '@/components/v2/31-chap27'
 import V232CHAP28 from '@/components/v2/32-chap28'
 import V31COVER from '@/components/v3/1-cover'
 import V32TITLE_PAGE from '@/components/v3/2-title_page'
 import V33DEDICATION from '@/components/v3/3-dedication'
 import V34TOC from '@/components/v3/4-TOC'
 import V35START from '@/components/v3/5-start'
 import V36CHAP2 from '@/components/v3/6-chap2'
 import V37CHAP3 from '@/components/v3/7-chap3'
 import V38CHAP4 from '@/components/v3/8-chap4'
 import V39CHAP5 from '@/components/v3/9-chap5'
 import V310CHAP6 from '@/components/v3/10-chap6'
 import V311CHAP7 from '@/components/v3/11-chap7'
 import V312CHAP8 from '@/components/v3/12-chap8'
 import V313CHAP9 from '@/components/v3/13-chap9'
 import V314CHAP10 from '@/components/v3/14-chap10'
 import V315CHAP11 from '@/components/v3/15-chap11'
 import V316CHAP12 from '@/components/v3/16-chap12'
 import V317CHAP13 from '@/components/v3/17-chap13'
 import V318CHAP14 from '@/components/v3/18-chap14'
 import V319CHAP15 from '@/components/v3/19-chap15'
 import V320CHAP16 from '@/components/v3/20-chap16'
 import V321CHAP17 from '@/components/v3/21-chap17'
 import V322CHAP18 from '@/components/v3/22-chap18'
 import V323CHAP19 from '@/components/v3/23-chap19'
 import V324CHAP20 from '@/components/v3/24-chap20'
 import V325CHAP21 from '@/components/v3/25-chap21'
 import V326CHAP22 from '@/components/v3/26-chap22'
 import V327CHAP23 from '@/components/v3/27-chap23'
 import V328CHAP24 from '@/components/v3/28-chap24'
 import V329CHAP25 from '@/components/v3/29-chap25'
 import V330CHAP26 from '@/components/v3/30-chap26'
 import V331PART from '@/components/v3/31-part'
 import V41COVER from '@/components/v4/1-cover'
 import V42TITLE_PAGE from '@/components/v4/2-title_page'
 import V43DEDICATION from '@/components/v4/3-dedication'
 import V44TOC from '@/components/v4/4-TOC'
 import V45START from '@/components/v4/5-start'
 import V46CHAP2 from '@/components/v4/6-chap2'
 import V47CHAP3 from '@/components/v4/7-chap3'
 import V48CHAP4 from '@/components/v4/8-chap4'
 import V49CHAP5 from '@/components/v4/9-chap5'
 import V410CHAP6 from '@/components/v4/10-chap6'
 import V411CHAP7 from '@/components/v4/11-chap7'
 import V412CHAP8 from '@/components/v4/12-chap8'
 import V413CHAP9 from '@/components/v4/13-chap9'
 import V414CHAP10 from '@/components/v4/14-chap10'
 import V415CHAP11 from '@/components/v4/15-chap11'
 import V416CHAP12 from '@/components/v4/16-chap12'
 import V417CHAP13 from '@/components/v4/17-chap13'
 import V418CHAP14 from '@/components/v4/18-chap14'
 import V419CHAP15 from '@/components/v4/19-chap15'
 import V420CHAP16 from '@/components/v4/20-chap16'
 import V421CHAP17 from '@/components/v4/21-chap17'
 import V422CHAP18 from '@/components/v4/22-chap18'
 import V423CHAP19 from '@/components/v4/23-chap19'
 import V424CHAP20 from '@/components/v4/24-chap20'
 import V425CHAP21 from '@/components/v4/25-chap21'
 import V426CHAP22 from '@/components/v4/26-chap22'
 import V427CHAP23 from '@/components/v4/27-chap23'
 import V428CHAP24 from '@/components/v4/28-chap24'
 import LOVE_2 from '@/components/love_2'
 import A1BIOGRAPHY from '@/components/31-biography'
 import A2COPYRIGHT from '@/components/32-copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/3-TOC",
 			"name" : "3-TOC",
 			"component" : ATOC
 		},
 		{
 			"path" : "/v1/1-cover",
 			"name" : "v1/1-cover",
 			"component" : V11COVER
 		},
 		{
 			"path" : "/v1/2-title_page",
 			"name" : "v1/2-title_page",
 			"component" : V12TITLE_PAGE
 		},
 		{
 			"path" : "/v1/3-dedication",
 			"name" : "v1/3-dedication",
 			"component" : V13DEDICATION
 		},
 		{
 			"path" : "/v1/4-TOC",
 			"name" : "v1/4-TOC",
 			"component" : V14TOC
 		},
 		{
 			"path" : "/v1/5-start",
 			"name" : "v1/5-start",
 			"component" : V15START
 		},
 		{
 			"path" : "/v1/6-chap2",
 			"name" : "v1/6-chap2",
 			"component" : V16CHAP2
 		},
 		{
 			"path" : "/v1/7-chap3",
 			"name" : "v1/7-chap3",
 			"component" : V17CHAP3
 		},
 		{
 			"path" : "/v1/8-chap4",
 			"name" : "v1/8-chap4",
 			"component" : V18CHAP4
 		},
 		{
 			"path" : "/v1/9-chap5",
 			"name" : "v1/9-chap5",
 			"component" : V19CHAP5
 		},
 		{
 			"path" : "/v1/10-chap6",
 			"name" : "v1/10-chap6",
 			"component" : V110CHAP6
 		},
 		{
 			"path" : "/v1/11-chap7",
 			"name" : "v1/11-chap7",
 			"component" : V111CHAP7
 		},
 		{
 			"path" : "/v1/12-chap8",
 			"name" : "v1/12-chap8",
 			"component" : V112CHAP8
 		},
 		{
 			"path" : "/v1/13-chap9",
 			"name" : "v1/13-chap9",
 			"component" : V113CHAP9
 		},
 		{
 			"path" : "/v1/14-chap10",
 			"name" : "v1/14-chap10",
 			"component" : V114CHAP10
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js